<template>
  <v-container>
    <v-row justify="space-around" dense>
      <v-col>
        <v-select
          v-model="bollettario"
          :items="bollettari"
          dense
          outlined
          label="Numeratore Fattura"
          hint="Seleziona il numeratore da utilizzare"
          persistent-hint
          item-text="descrizione"
          item-value="codice"
          clearable
        ></v-select>
      </v-col>
      <v-col>
        <v-menu
          v-model="showDataFattura"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              :value="computedDataFormatted"
              label="Data fattura"
              prepend-inner-icon="mdi-calendar"
              readonly
              outlined
              dense
              v-bind="attrs"
              v-on="on"
              clearable
              @click:clear="dataFattura = null"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="dataFattura"
            no-title
            scrollable
            @input="showDataFattura = false"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col>
        <v-select
          v-model="modulo"
          :items="moduliStampa"
          dense
          chips
          small-chips
          flat
          outlined
          multiple
          label="Tipo Modulo"
          hint="Seleziona il modulo da utilizzare per la stampa"
          persistent-hint
          item-text="descrizione"
          item-value="codice"
          clearable
        ></v-select>
      </v-col>
      <v-spacer></v-spacer>
      <!-- <v-col cols="1"><v-btn @click.stop="onFiltra">Ricerca</v-btn></v-col> -->
    </v-row>
    <v-row justify="space-around" dense align="center">
      <v-col>
        <v-card
          class="mx-auto"
          max-width="300"
          outlined
          :loading="loadingFattureDdt"
        >
          <template slot="progress">
            <v-progress-linear
              color="deep-purple"
              height="3"
              indeterminate
            ></v-progress-linear>
          </template>
          <v-list-item three-line>
            <v-list-item-content>
              <div class="text-overline">
                Documenti di trasporto
              </div>
              <v-list-item-subtitle class="text--primary"
                >Elenco ddt nel periodo scelto</v-list-item-subtitle
              >
              <!-- eslint-disable-next-line -->
              <v-list-item-subtitle v-text="periodoDdt"></v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-card-text class="pb-0">
            Clienti selezionati: {{ clientiDdt.length }}
          </v-card-text>
          <v-card-text class="pb-0">
            DDT Selezionati: {{ ddt.length }}
          </v-card-text>
          <v-card-actions>
            <v-switch
              v-model="dettaglioDDT"
              inset
              label="Includi dettaglio DDT"
            ></v-switch>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col>
        <v-card
          class="mx-auto"
          max-width="300"
          outlined
          :loading="loadingFattureScontrini"
        >
          <template slot="progress">
            <v-progress-linear
              color="deep-purple"
              height="3"
              indeterminate
            ></v-progress-linear>
          </template>
          <v-list-item three-line>
            <v-list-item-content>
              <div class="text-overline">
                Scontrini
              </div>
              <v-list-item-subtitle class="text--primary"
                >Elenco scontrini nel periodo scelto</v-list-item-subtitle
              >
              <!-- eslint-disable-next-line -->
              <v-list-item-subtitle
                v-text="periodoScontrini"
              ></v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-card-text class="pb-0">
            Clienti selezionati: {{ clientiScontrini.length }}
          </v-card-text>
          <v-card-text class="pb-0">
            Scontrini Selezionati: {{ scontrini.length }}
          </v-card-text>
          <v-card-actions>
            <v-switch
              v-model="dettaglioScontrini"
              inset
              label="Includi dettaglio Scontrini"
            ></v-switch>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col>
        <v-btn color="success" @click.stop="onGeneraProforma"
          >Genera Anteprima Fatture</v-btn
        >
      </v-col>
      <v-spacer></v-spacer>
    </v-row>
    <v-alert
      :value="noPagamento"
      class="mt-5 mb-5"
      dismissible
      prominent
      dense
      type="warning"
      @input="onAlertDismiss"
    >
      <br />
      <h3 class="d-flex justify-center">
        Per i seguenti clienti non è stato definito un pagamento in anagrafica.
        E' necessario correggere il cliente ed aggiornare i DDT
      </h3>
      <br />
      <p v-for="(cliente, index) in elencoClientiNoPagamento" :key="index">
        {{ `${cliente.codice} - ${cliente.ragioneSociale} ` }}
      </p>
    </v-alert>
    <v-alert
      :value="presenzaFatturate && !loadingFattureDdt"
      class="mt-5 mb-5"
      dismissible
      prominent
      dense
      type="warning"
      color="red lighten-2"
    >
      Per alcuni DDT risultano già presenti le fatture proforma. <br />
      Selezionare la tab "Anteprima" <br />
      Eliminare le fatture proforma e ripetere l'operazione. <br /><br />

      <p v-for="(fattura, index) in elencoFattureProformaPresenti" :key="index">
        {{ `${fattura.numero} - ${fattura.cliente}` }}
      </p>
    </v-alert>
  </v-container>
</template>

<script>
/* eslint-disable */
import _ from "lodash";
import moment from "moment";
import configurazioni from "@/services/configurazioniService.js";
import clienti from "@/services/clientiService.js";
import scontrini from "@/services/scontriniService.js";
import documenti from "@/services/documentiService.js";
import fatturazione from "./fatturazione.js";

export default {
  props: {
    ddt: Array,
    clientiDdt: Array,
    scontrini: Array,
    clientiScontrini: Array,
    dateDdt: Object,
    dateScontrini: Object,
  },
  data: (vm) => ({
    bollettari: [],
    bollettario: null,
    moduliStampa: [],
    modulo: null,
    loading: false,
    dettaglioDDT: true,
    dettaglioScontrini: false,
    dataFormatted: vm.formatDate(
      new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10)
    ),
    dataFattura: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    showDataFattura: false,
    loadingFattureDdt: false,
    loadingFattureScontrini: false,
    proforma: null,
    modalitaPagamento: null,
    condizioniPagamento: null,
    speseFattura: null,
    banche: null,
    repartiFiscali: null,
    noPagamento: false,
    elencoClientiNoPagamento: [],
    interrompiCicloSePresenzaFatturate: false,
    presenzaFatturate: false,
    elencoFattureProformaPresenti: [],
  }),
  async mounted() {
    this.$emit("ricerca", this.filtro);
    // const impostazioni = await configurazioni.getConfigurazione('documenti_parametri', 'tipiDocumento')
    const parametri = await configurazioni.getConfigurazione(
      "documenti_parametri"
    );
    const impostazioni = parametri.tipiDocumento;
    this.bollettari = impostazioni.filter(
      (x) => x.tipoDocumento === "fatturaRiepilogativa24"
    );
    this.bollettario = this.bollettari.map((x) => x.codice)[0]; // deve prendere solo il primo !!
    this.proforma = impostazioni.find(
      (x) => x.tipoDocumento === "fatturaProforma"
    );
    const doc_pagamenti = await configurazioni.getConfigurazione(
      "documenti_pagamento"
    );
    this.modalitaPagamento = doc_pagamenti.modalitaPagamento;
    this.condizioniPagamento = doc_pagamenti.condizioniPagamento;
    this.speseFattura = doc_pagamenti.spese;
    this.banche = doc_pagamenti.banche;

    this.dettaglioDDT = _.get(
      parametri,
      "fatturaRiepilogativa.dettaglioDDT",
      true
    );
    this.dettaglioScontrini = _.get(
      parametri,
      "fatturaRiepilogativa.dettaglioScontrini",
      false
    );
    this.interrompiCicloSePresenzaFatturate = _.get(
      parametri,
      "fatturaRiepilogativa.interrompiCicloSePresenzaFatturate",
      false
    );

    let repartiFiscali = await configurazioni.getConfigurazione(
      "prodotti_reparti_fiscali",
      "reparti"
    );
    const aliquote = await configurazioni.getConfigurazione(
      "prodotti_aliquote_iva",
      "aliquote"
    );
    repartiFiscali = repartiFiscali.map((x) => {
      const iva = aliquote.find((al) => al.codice === x.codiceIva);
      if (iva) {
        return {
          repartoFiscale: x.stampante.numero,
          tipoBene: x.descrizione,
          descrizione: "Iva: " + iva.descrizione,
          aliquota: iva.aliquota,
        };
      } else {
        return {
          repartoFiscale: x.stampante.numero,
          tipoBene: x.descrizione,
          descrizione: "Iva: non definita",
          aliquota: 0,
        };
      }
    });
    this.repartiFiscali = _.uniqBy(repartiFiscali, "repartoFiscale");
  },
  computed: {
    computedDataFormatted() {
      return this.formatDate(this.dataFattura);
    },
    periodoDdt() {
      const date = this.dateDdt;
      if (!date) return "";
      const da = date.start
        ? moment(date.start, "YYYY-MM-DD").format("DD/MM/YYYY")
        : "fino al";
      const a = date.end
        ? moment(date.end, "YYYY-MM-DD").format("DD/MM/YYYY")
        : "e seguenti";
      const periodo = `${da} - ${a}`;
      return periodo;
    },
    periodoScontrini() {
      const date = this.dateScontrini;
      if (!date) return "";
      const da = date.start
        ? moment(date.start, "YYYY-MM-DD").format("DD/MM/YYYY")
        : "fino al";
      const a = date.end
        ? moment(date.end, "YYYY-MM-DD").format("DD/MM/YYYY")
        : "e seguenti";
      const periodo = `${da} - ${a}`;
      return periodo;
    },
  },
  watch: {
    dataFattura(val) {
      this.dataFormatted = this.formatDate(this.dataFattura);
    },
  },
  methods: {
    onAlertDismiss(value) {
      this.noPagamento = false;
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;
      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    async getValuesFull(source, filtroCampo, filtroValore) {
      let elementi = [];
      let elementiFull = [];
      if (typeof source === "string") {
        const config = source.split(".");
        const configId = config[0];
        const subId = config[1] || ""; // TODO verificare
        const sub2 = config[2] || "";
        const sourceArray = await configurazioni.getConfigurazione(
          configId,
          subId
        );
        if (sub2) {
          elementiFull = sourceArray
            ? sourceArray.filter((x) => x.tipo === sub2)
            : [];
        } else {
          elementiFull = sourceArray ? sourceArray : [];
        }
        if (filtroCampo && filtroValore) {
          elementiFull = elementiFull.filter(
            (x) => _.get(x, filtroCampo, "") === filtroValore
          );
        }
        // elementi = elementiFull.map(x => { return { codice: x.codice, descrizione: x.descrizione } })
        elementi = elementiFull;
      } else if (Array.isArray(source)) {
        elementi = [...source];
      }
      return elementi;
    },
    async onGeneraProforma() {
      /*
          1) Verificare la presenza dei pagamenti bloccare tutto e segnalare, altrimenti va in errore la generazione --> Ciclo su tutti i clienti selezionati
          2) Verificare che la DDT non abbia già una proforma creata, altrimenti segnala che verranno generate solo le proforma mancanti e procede
          3) Possibilità di cancellazione delle proforma --> possibilità di ricreare
        */
      const cpm = await this.verificaPagamentiInseriti();
      if (cpm.length > 0) {
        this.elencoClientiNoPagamento = cpm;
        this.noPagamento = true;
      } else {
        await this.generaProformaDdt();
        await this.generaProformaScontrini();
        if (!this.presenzaFatturate) {
          this.$emit("generazione-completa");
        } else {
          setTimeout(() => {
            this.presenzaFatturate = false;
          }, 30000);
        }
      }
    },
    async verificaPagamentiInseriti() {
      this.loadingFattureDdt = true;
      let clientiConPagamentiMancanti = [];

      for (const cls of this.clientiDdt) {
        const cliente = await clienti.getCliente(cls);
        const ddtCliente = this.ddt.filter(
          (x) => x.anagrafica.cliente.codice === cliente.codice
        );
        if (ddtCliente.length === 0) {
          continue;
        }
        let clienteOk = false;
        let pg = _.get(cliente, "amministrativi.pagamento");
        if (pg) {
          if (pg.condizioni) {
            const condizioniPagamento = this.condizioniPagamento.find(
              (x) => x.codice === pg.condizioni
            );
            if (condizioniPagamento) {
              clienteOk = true;
            }
          }
          if (pg.dettaglio && pg.dettaglio.modalita) {
            const modalitaPagamento = this.modalitaPagamento.find(
              (x) => x.codice === pg.dettaglio.modalita
            );
            if (modalitaPagamento) {
              clienteOk = true;
            }
          }
        }
        if (!clienteOk) {
          clientiConPagamentiMancanti.push({
            codice: cliente.codice,
            ragioneSociale: cliente.ragioneSociale,
          });
        }
      }
      this.loadingFattureDdt = false;
      return clientiConPagamentiMancanti;
    },
    async generaProformaDdt() {
      this.loadingFattureDdt = true;
      const tipoDocumento = this.bollettari.find(
        (x) => x.codice === this.bollettario
      );
      const annoRiferimento = this.dataFattura.substring(0, 4);
      this.presenzaFatturate = false;
      this.elencoFattureProformaPresenti = [];

      for (const cls of this.clientiDdt) {
        if (!this.interrompiCicloSePresenzaFatturate) {
          this.presenzaFatturate = false;
        }
        const cliente = await clienti.getCliente(cls);
        const ddtCliente = this.ddt.filter(
          (x) => x.anagrafica.cliente.codice === cliente.codice
        );
        if (ddtCliente.length === 0) {
          continue;
        }
        // deve ciclare sui tipi di pagamento diversi nelle varie ddt del cliente ?
        let pg = cliente.amministrativi.pagamento; // va considerata anche la modifica del pagamento fatta nella prima scheda. Quello del cliente è già nell'anagrafica
        const modalitaPagamento = this.modalitaPagamento.find(
          (x) => x.codice === pg.dettaglio.modalita
        );
        let condizioniPagamento = this.condizioniPagamento.find(
          (x) => x.codice === pg.condizioni
        ) || { codice: "TP02", descrizione: "Pagamento completo" };
        const banca = modalitaPagamento.infoBanca
          ? this.banche.find((x) => x.codice === modalitaPagamento.infoBanca)
          : null;
        const sede =
          cliente.recapiti.length > 0
            ? cliente.recapiti.find((x) => x.tipo.codice === "principale")
            : {}; // considerare anche eventuale modifica
        const speseFattura = cliente.fatturazione.spese || []; // considerare anche eventuale modifica
        const numeratore = this.proforma.numeratore;
        let esigibilita = cliente.amministrativi.esigibilitaIva

        // const numero = await configurazioni.getNumeratore(numeratore, true, annoRiferimento)
        let fattura = {
          /*             _id: numero,
                        codice: numero, */
          data: this.dataFattura,
          tipoDocumento: this.proforma, // Sto generando la proforma, porto dietro le info per la fattura finale in "fatturazione"
          // TODO: Verificare. Nel momento della generazione della fattura definitiva viene sostituito dal contenuto di fatturazione.tipoDocumento
          anagrafica: {
            cliente: cliente,
          },
          pagamento: {
            condizioni: {
              codice: condizioniPagamento.codice,
              descrizione: condizioniPagamento.descrizione,
            },
            modalita: {
              codice: modalitaPagamento.codice,
              codiceXml: modalitaPagamento.codiceXml,
              descrizione: modalitaPagamento.descrizione,
            },
            infoBanca: banca,
          },
          spedizione: {
            destinazione: sede,
          },
          fatturazione: {
            // informazioni per la generazione definitiva della fattura differita
            tipoDocumento,
            // eventuale modulo diverso dallo standard
          },
        };
        if(esigibilita){
          fattura.tipoDocumento.esigibilitaIva = esigibilita
        }
        fattura.anagrafica.cliente.descrizione =
          fattura.anagrafica.cliente.ragioneSociale;
        let righe = [];
        var totali = {};
        // const ddtCliente =  this.ddt.filter(x => x.anagrafica.cliente.codice === cliente.codice)
        if (!this.dettaglioDDT) {
          for (const documento of ddtCliente) {
            const ddt = await documenti.getDocumento(documento._id);
            const fRiep = _.get(ddt, "tipoDocumento.fatturaRiepilogativa", "");
            if (fRiep) {
              this.presenzaFatturate = true;
              if (
                !this.elencoFattureProformaPresenti.find(
                  (x) => x.numero === fRiep
                )
              ) {
                this.elencoFattureProformaPresenti.push({
                  numero: fRiep,
                  cliente: cliente.ragioneSociale,
                });
              }
              continue;
            }
            var valori;
            if (ddt.scontrino) {
              const scontrino = await scontrini.getScontrinoById(ddt.scontrino);
              valori = await fatturazione.calcolaValoriScontrino(scontrino);
            } else {
              valori = fatturazione.calcolaValoriDocumento(
                ddt,
                this.repartiFiscali
              );
            }
            totali = fatturazione.calcolaTotaliAliquote_v2(totali, valori);
            let riga = {
              rigaDescrittiva: true,
              descrizione: `DDT n. ${ddt.codice} del ${moment(ddt.data).format(
                "DD/MM/YYYY"
              )}`,
              bold: true,
            };
            righe.push(riga);
            let altriDati = {
              tipoDato: "ddt",
              riferimentoTesto: riga.descrizione,
              riferimentoData: moment(ddt.data).format("YYYY-MM-DD"),
            };
            for (let rep of valori) {
              riga = {
                rigaDescrittiva: false,
                rigaIndentata: true,
                descrizione: `Reparto: ${rep.tipoBene}`,
                quantita: rep.quantita,
                prezzo: rep.importoTotale,
                sconto: rep.sconto,
                valore: rep.prezzoTotale,
                imponibile: rep.importoNettoTotale, // rep.prezzoNettoTotale,
                iva: rep.iva,
                aliquota: rep.aliquota,
                aliquotaIva: {
                  codice: rep.aliquotaIva,
                  descrizione: rep.descrizione,
                  aliquota: rep.aliquota,
                  valore: rep.aliquota,
                },
                aliquotaDescrizione: rep.descrizione,
                reparto: rep.repartoFiscale,
                valore: {
                  sconto1: null,
                  sconto2: null,
                  sconto3: null,
                  sconto4: null,
                  prezzoUnitario: rep.prezzoUnitario,
                  prezzoTotale: rep.prezzoTotale,
                  prezzoNettoUnitario: rep.prezzoNettoUnitario,
                  prezzoNettoTotale: rep.prezzoNettoTotale,
                  importoUnitario: rep.importoUnitario,
                  importoTotale: rep.importoTotale,
                  importoNettoUnitario: rep.importoNettoUnitario,
                  importoNettoTotale: rep.importoNettoTotale,
                },
                altriDati,
              };
              righe.push(riga);
            }
            const numero = await configurazioni.getNumeratore(
              numeratore,
              true,
              annoRiferimento
            );
            fattura._id = numero;
            fattura.codice = numero;
            ddt.tipoDocumento.fatturaRiepilogativa = numero;
            await documenti.aggiornaDocumento(ddt);
          }
        } else {
          for (const documento of ddtCliente) {
            const ddt = await documenti.getDocumento(documento._id);
            const fRiep = _.get(ddt, "tipoDocumento.fatturaRiepilogativa", "");
            if (fRiep) {
              this.presenzaFatturate = true;
              if (
                !this.elencoFattureProformaPresenti.find(
                  (x) => x.numero === fRiep
                )
              ) {
                this.elencoFattureProformaPresenti.push({
                  numero: fRiep,
                  cliente: cliente.ragioneSociale,
                });
              }
              continue;
              /*               if (_.get(ddt, 'tipoDocumento.fatturaRiepilogativa', '')) {
                                this.presenzaFatturate = true
                                continue */
            }
            var valori;
            var dettaglio;
            if (ddt.scontrino) {
              const scontrino = await scontrini.getScontrinoById(ddt.scontrino);
              valori = await fatturazione.calcolaValoriScontrino(scontrino);
              dettaglio = await fatturazione.calcolaDettaglioScontrino(
                scontrino
              );
            } else {
              // valori = fatturazione.calcolaValoriDdt(ddt, this.repartiFiscali)
              valori = fatturazione.calcolaValoriDocumento(
                ddt,
                this.repartiFiscali
              );
              dettaglio = fatturazione.calcolaDettaglioDdt(
                ddt,
                this.repartiFiscali
              );
            }

            const scontoInFattura = documento.scontoFattura || 0;

            const totImpo = _.sumBy(valori, (el) => {
              return el.importoNettoTotale;
            });
            const totaleMerce = totImpo - scontoInFattura; // Si parte dalla somma dei prodotti meno lo sconto in fattura
            const { spese, totaleSpese } = fatturazione.calcolaSpese(
              speseFattura,
              totaleMerce
            );

            // totali = fatturazione.calcolaTotaliAliquote_v2(totali, valori)
            totali = fatturazione.calcolaTotaliAliquote_v2(
              totali,
              valori,
              spese,
              scontoInFattura,
              totaleMerce
            );
            let riga = {
              rigaDescrittiva: true,
              descrizione: `DDT n. ${ddt.codice} del ${moment(ddt.data).format(
                "DD/MM/YYYY"
              )}`,
              bold: true,
            };
            righe.push(riga);
            let altriDati = {
              tipoDato: "ddt",
              riferimentoTesto: riga.descrizione,
              riferimentoData: moment(ddt.data).format("YYYY-MM-DD"),
            };
            for (let rep of dettaglio) {
              riga = {
                rigaDescrittiva: false,
                rigaIndentata: true,
                codice: rep.item.codice,
                prodotto: { codice: rep.item.codice },
                unitaMisura: rep.unitaMisura,
                omaggio: rep.omaggio || false,
                descrizione: rep.item.descrizione || `Reparto: ${rep.tipoBene}`,
                quantita: rep.quantita,
                prezzo: rep.importoTotale,
                sconto: rep.sconto,
                valore: rep.prezzoTotale,
                imponibile: rep.importoNettoTotale, // rep.prezzoNettoTotale,
                iva: rep.iva,
                aliquota: rep.aliquota,
                aliquotaIva: {
                  codice: rep.aliquotaIva,
                  descrizione: rep.descrizione,
                  aliquota: rep.aliquota,
                  valore: rep.aliquota,
                },
                aliquotaDescrizione: rep.descrizione,
                reparto: rep.repartoFiscale,
                valore: {
                  listino: rep.listino,
                  sconto1: rep.sconto1,
                  sconto2: rep.sconto2,
                  sconto3: rep.sconto3,
                  sconto4: rep.sconto4,
                  prezzoUnitario: rep.prezzoUnitario,
                  prezzoTotale: rep.prezzoTotale,
                  prezzoNettoUnitario: rep.prezzoNettoUnitario,
                  prezzoNettoTotale: rep.prezzoNettoTotale,
                  importoUnitario: rep.importoUnitario,
                  importoTotale: rep.importoTotale,
                  importoNettoUnitario: rep.importoNettoUnitario,
                  importoNettoTotale: rep.importoNettoTotale,
                },
                altriDati,
              };
              righe.push(riga);
            }
            const numero = await configurazioni.getNumeratore(
              numeratore,
              true,
              annoRiferimento
            );
            fattura._id = numero;
            fattura.codice = numero;
            ddt.tipoDocumento.fatturaRiepilogativa = numero;
            await documenti.aggiornaDocumento(ddt);
          }
        }
        if (this.presenzaFatturate) {
          // TODO: Verificare
          continue;
        }
        // TODO: sistemare: deve fare la somma di quelli calcolati prima
        // const totaleCompleti = fatturazione.calcolaTotaliAliquoteSpese(totali, speseFattura/* , scontoInFattura */)
        const totaleCompleti = totali;
        const splitPayment = esigibilita && esigibilita.codice === 'S'
        const scadenze = fatturazione.calcolaScadenze(
          totaleCompleti,
          modalitaPagamento,
          splitPayment
        );
        // TODO: Sistemare, deve fare la somma di quelle calcolate prima
        const { spese, totaleSpese } = fatturazione.calcolaSpese(
          speseFattura,
          totaleCompleti.generale.imponibile,
          totaleCompleti.generale.imponibile
        );
        fattura.righe = righe;
        fattura.totali = totaleCompleti;
        fattura.scadenze = scadenze;
        if (scadenze.length > 1) {
          fattura.pagamento.condizioni.codice = "TP01";
          fattura.pagamento.condizioni.descrizione = "Pagamento a rate";
        }
        fattura.spese = spese;
        await documenti.creaDocumento(fattura);
      }
      this.loadingFattureDdt = false;
    },

    async generaProformaScontrini() {
      this.loadingFattureScontrini = true;
      const tipoDocumento = this.bollettari.find(
        (x) => x.codice === this.bollettario
      );
      const annoRiferimento = this.dataFattura.substring(0, 4);
      for (const cls of this.clientiScontrini) {
        const cliente = await clienti.getCliente(cls);
        let pg = cliente.amministrativi.pagamento; // va considerata anche la modifica del pagamento fatta nella prima scheda. Quello del cliente è già nell'anagrafica
        const modalitaPagamento = this.modalitaPagamento.find(
          (x) => x.codice === pg.dettaglio.modalita
        );
        let condizioniPagamento = this.condizioniPagamento.find(
          (x) => x.codice === pg.condizioni
        );
        const banca = modalitaPagamento.infoBanca
          ? this.banche.find((x) => x.codice === modalitaPagamento.infoBanca)
          : null;
        const sede =
          cliente.recapiti.length > 0
            ? cliente.recapiti.find((x) => x.tipo.codice === "principale")
            : {}; // considerare anche eventuale modifica
        const speseFattura = cliente.fatturazione.spese || []; // considerare anche eventuale modifica
        const numeratore = this.proforma.numeratore;
        const numero = await configurazioni.getNumeratore(
          numeratore,
          true,
          annoRiferimento
        );
        let esigibilita = cliente.amministrativi.esigibilitaIva
        let fattura = {
          _id: numero,
          codice: numero,
          data: this.dataFattura,
          tipoDocumento: this.proforma, // Sto generando la proforma, porto dietro le info per la fattura finale in "fatturazione"
          anagrafica: {
            cliente: cliente,
          },
          pagamento: {
            condizioni: condizioniPagamento.codice,
            dettaglio: {
              modalita: modalitaPagamento.codice,
              descrizione: modalitaPagamento.descrizione,
            },
            infoBanca: banca,
            codiceXml: modalitaPagamento.codiceXml,
          },
          spedizione: {
            destinazione: sede,
          },
          fatturazione: {
            // informazioni per la generazione definitiva della fattura differita
            tipoDocumento,
            // eventuale modulo diverso dallo standard
          },
        };
        if(esigibilita){
          fattura.tipoDocumento.esigibilitaIva = esigibilita
          fattura.fatturazione.tipoDocumento.esigibilitaIva = esigibilita
        }
        fattura.anagrafica.cliente.descrizione =
          fattura.anagrafica.cliente.ragioneSociale;
        let righe = [];
        var totali = {};
        const scontriniCliente = this.scontrini.filter(
          (x) => x.cliente.codice === cliente.codice
        );
        if (!this.dettaglioScontrini) {
          for (const scn of scontriniCliente) {
            const scontrino = await scontrini.getScontrinoById(scn._id);
            const valori = await fatturazione.calcolaValoriScontrino(scontrino);
            totali = fatturazione.calcolaTotaliAliquote(totali, valori);

            let riga = {
              rigaDescrittiva: true,
              // descrizione: `Scontrino n. ${scontrino.fiscale.ricerca.documento} del ${moment(scontrino.fiscale.data).format('DD/MM/YYYY')}`
            };
            riga.descrizione = scontrino.fiscale
              ? `Scontrino n. ${
                  scontrino.fiscale.ricerca.documento
                } del ${moment(scontrino.fiscale.data).format("DD/MM/YYYY")}`
              : `Scontrino del ${moment(scontrino._id, "YYYY-MM-DD").format(
                  "DD/MM/YYYY"
                )}`;
            righe.push(riga);
            let altriDati = {
              tipoDato: "scontrino",
              riferimentoTesto: riga.descrizione,
              riferimentoData: scontrino.fiscale
                ? moment(scontrino.fiscale.data).format("YYYY-MM-DD")
                : moment(scontrino._id, "YYYY-MM-DD").format("YYYY-MM-DD"),
            };
            for (let rep of valori) {
              let riga = {
                rigaDescrittiva: false,
                rigaIndentata: true,
                // descrizione: `Scontrino n. ${scontrino.fiscale.ricerca.documento} del ${moment(scontrino.fiscale.data).format('DD/MM/YYYY')} reparto: ${rep.tipoBene}`,
                descrizione: `Reparto: ${rep.tipoBene}`,
                quantita: rep.quantita,
                unitaMisura: "n",
                // Adeguare i valori in base ai campi richiesti ...
                prezzo: rep.prezzo,
                sconto: rep.sconto,
                valore: rep.valore,
                imponibile: rep.imponibile,
                iva: rep.iva,
                aliquota: rep.aliquota,
                // aliquotaIva: { codice: rep.aliquotaIva },
                aliquotaIva: {
                  codice: rep.codice,
                  descrizione: rep.descrizione,
                  aliquota: rep.aliquota,
                  valore: rep.aliquota,
                },
                repartoFiscale: String(_.get(rep, "stampante.posizione")),
                aliquotaDescrizione: rep.descrizione,
                reparto: _.get(rep, "stampante.posizione"), // rep.repartoFiscale,
                valore: {
                  sconto1: null,
                  sconto2: null,
                  sconto3: null,
                  sconto4: null,
                  prezzoUnitario: rep.prezzoUnitario,
                  prezzoTotale: rep.prezzoTotale,
                  prezzoNettoUnitario: rep.prezzoNettoUnitario,
                  prezzoNettoTotale: rep.prezzoNettoTotale,
                  importoUnitario: rep.importoUnitario,
                  importoTotale: rep.importoTotale,
                  importoNettoUnitario: rep.importoNettoUnitario,
                  importoNettoTotale: rep.importoNettoTotale,
                  listino: {
                    codice: "L1",
                    descrizione: "Listino Base",
                    ivato: true,
                  },
                },
                altriDati,
              };
              righe.push(riga);
            }

            //aggiorna scontrino perché è stato fatturato
            scontrino.documento.tipoDocumento.fatturaRiepilogativa = numero;
            await scontrini.updateScontrino(scontrino._id, scontrino);
          }
        } else {
          for (const scn of scontriniCliente) {
            const scontrino = await scontrini.getScontrinoById(scn._id);
            const valori = await fatturazione.calcolaValoriScontrino(scontrino);
            const dettaglio = await fatturazione.calcolaDettaglioScontrino(
              scontrino
            );
            totali = fatturazione.calcolaTotaliAliquote(totali, valori);

            let riga = {
              rigaDescrittiva: true,
              // descrizione: `Scontrino n. ${scontrino.fiscale.ricerca.documento} del ${moment(scontrino.fiscale.data).format('DD/MM/YYYY')}`
            };
            /*               riga.descrizione = scontrino.fiscale ? `Scontrino n. ${scontrino.fiscale.ricerca.documento} del ${moment(scontrino.fiscale.data).format('YYYY-MM-DD')}` : `Scontrino del ${moment(scontrino._id).format('YYYY-MM-DD')}`
                            let altriDati = { tipoDato: 'scontrino', riferimentoTesto: riga.descrizione, riferimentoData: scontrino.fiscale ? moment(scontrino.fiscale.data).format('YYYY-MM-DD') : moment(scontrino._id).format('YYYY-MM-DD')}
               */
            riga.descrizione = scontrino.fiscale
              ? `Scontrino n. ${
                  scontrino.fiscale.ricerca.documento
                } del ${moment(scontrino.fiscale.data).format("DD/MM/YYYY")}`
              : `Scontrino del ${moment(scontrino._id, "YYYY-MM-DD").format(
                  "DD/MM/YYYY"
                )}`;
            let altriDati = {
              tipoDato: "scontrino",
              riferimentoTesto: riga.descrizione,
              riferimentoData: scontrino.fiscale
                ? moment(scontrino.fiscale.data).format("YYYY-MM-DD")
                : moment(scontrino._id, "YYYY-MM-DD").format("YYYY-MM-DD"),
            };
            righe.push(riga);
            for (let rep of dettaglio) {
              if (rep.rigaDescrittiva) {
                righe.push(rep);
                continue;
              }
              let riga = {
                rigaDescrittiva: false,
                rigaIndentata: true,
                // descrizione: `Scontrino n. ${scontrino.fiscale.ricerca.documento} del ${moment(scontrino.fiscale.data).format('DD/MM/YYYY')} reparto: ${rep.tipoBene}`,
                codice: rep.item.codice,
                descrizione: rep.item.descrizione || `Reparto: ${rep.tipoBene}`,
                quantita: rep.quantita,
                unitaMisura: "n",
                // Adeguare i valori in base ai campi richiesti ...
                prezzo: rep.prezzo,
                sconto: rep.sconto,
                valore: rep.valore,
                imponibile: rep.imponibile,
                iva: rep.iva,
                aliquota: rep.aliquota,
                aliquotaDescrizione: rep.descrizione,
                aliquotaIva: {
                  codice: rep.codice,
                  descrizione: rep.descrizione,
                  aliquota: rep.aliquota,
                  valore: rep.aliquota,
                },
                repartoFiscale: rep.repartoFiscale,
                reparto: rep.repartoFiscale,
                valore: {
                  sconto1: null,
                  sconto2: null,
                  sconto3: null,
                  sconto4: null,
                  prezzoUnitario: rep.prezzoUnitario,
                  prezzoTotale: rep.prezzoTotale,
                  prezzoNettoUnitario: rep.prezzoNettoUnitario,
                  prezzoNettoTotale: rep.prezzoNettoTotale,
                  importoUnitario: rep.importoUnitario,
                  importoTotale: rep.importoTotale,
                  importoNettoUnitario: rep.importoNettoUnitario,
                  importoNettoTotale: rep.importoNettoTotale,
                  listino: {
                    codice: "L1",
                    descrizione: "Listino Base",
                    ivato: true,
                  },
                },
                altriDati,
              };
              righe.push(riga);
            }

            //aggiorna scontrino perché è stato fatturato
            scontrino.documento.tipoDocumento.fatturaRiepilogativa = numero;
            await scontrini.updateScontrino(scontrino._id, scontrino);
          }
        }
        const totaleCompleti = fatturazione.calcolaTotaliAliquoteSpese(
          totali,
          speseFattura /* , scontoInFattura */
        );
        const splitPayment = esigibilita && esigibilita.codice === 'S'
        const scadenze = fatturazione.calcolaScadenze(
          totaleCompleti,
          modalitaPagamento,
          splitPayment
        );
        const { spese, totaleSpese } = fatturazione.calcolaSpese(
          speseFattura,
          totaleCompleti.generale.imponibile,
          totaleCompleti.generale.imponibile
        );
        fattura.righe = righe;
        fattura.totali = totaleCompleti;
        fattura.scadenze = scadenze;
        if (scadenze.length > 1) {
          fattura.pagamento.condizioni.codice = "TP01";
          fattura.pagamento.condizioni.descrizione = "Pagamento a rate";
        }
        fattura.spese = spese;
        await documenti.creaDocumento(fattura);
        // aggiorna fatturati: registra numero fattura
      }
      this.loadingFattureScontrini = false;
    },
  },
};
</script>
